import { ContentfulNavigation } from "../../@types/contentfulNavigation";
import {
  ICardCarousel,
  IContentSection,
  IHeroArticle,
  IHeroArticleFields,
  IHeroTeaser,
  IHeroTeaserFields,
  IPageFields,
  IRecipeSection,
} from "../../@types/generated/contentful";
import CustomContainer from "../../components/container";
import ContentSectionWrapper from "../../components/content-section-wrapper";
import CountdownBar from "../../components/countdown-bar";
import HeroTeaser from "../../components/hero-teaser";
import HeroTeaserArticle from "../../components/hero-teaser-article";
import PageLayout from "../../components/page/layout";
import { TableOfContentsEntry } from "../../components/table-of-contents";
import generateTitle from "../../utils/page/generateTitle";
import { JointPageProperties } from "../../utils/page/getJointPageProperties";

interface PageProps {
  isPreview?: boolean;
  page: IPageFields;
  previewData?: any;
  navigation: ContentfulNavigation;
  jointPageProperties: JointPageProperties;
}

export default function ContentPage({
  isPreview,
  page,
  previewData,
  navigation,
  jointPageProperties,
}: PageProps) {
  const {
    contentSections,
    heroTeaser,
    seoMetadata,
    countdownPage,
    noNavigation,
    tenant,
  } = page;
  const {
    fields: { title },
  } = seoMetadata;
  const { footerProps } = jointPageProperties;
  const {
    logoDark,
    logoLight,
    titleSuffix,
    bannerVisible,
    bannerText,
    bannerIcon,
  } = jointPageProperties.siteSettings;

  const fullTitle = generateTitle(title, titleSuffix);

  return (
    <PageLayout
      title={fullTitle}
      footer={footerProps}
      logoHeader={logoDark}
      logoFooter={logoLight}
      navigation={navigation}
      bannerVisible={bannerVisible}
      bannerText={bannerText}
      bannerIcon={bannerIcon}
      metadata={seoMetadata.fields}
      noNavigation={noNavigation}
      tenant={tenant}
    >
      {heroTeaser && getHero(heroTeaser, contentSections)}
      {contentSections?.map((section, i) => (
        <ContentSectionWrapper
          key={`section-${i}`}
          section={section}
        ></ContentSectionWrapper>
      ))}
      {countdownPage && <CountdownBar {...countdownPage.fields}></CountdownBar>}
    </PageLayout>
  );
}

export function getHero(
  heroTeaser: IHeroTeaser | IHeroArticle,
  contentSections:
    | (IContentSection | ICardCarousel | IRecipeSection)[]
    | undefined,
  tableOfContents?: TableOfContentsEntry[],
  isDocFleckPlusSalespage?: boolean
) {
  if (heroTeaser?.sys.contentType.sys.id === "heroTeaser") {
    const fields = heroTeaser.fields as IHeroTeaserFields;
    return (
      <CustomContainer
        backgroundColor={fields.backgroundColor || "none"}
        isDocFleckPlusSalespage={isDocFleckPlusSalespage}
      >
        <HeroTeaser
          {...fields}
          isDocFleckPlusSalespage={isDocFleckPlusSalespage}
        />
      </CustomContainer>
    );
  } else if (heroTeaser.sys.contentType.sys.id === "heroArticle") {
    const fields = heroTeaser.fields as IHeroArticleFields;
    return (
      <CustomContainer lowBottomPadding={true} backgroundColor={"none"}>
        <HeroTeaserArticle
          contentSections={contentSections}
          {...(fields as IHeroArticleFields)}
          tableOfContents={tableOfContents}
        ></HeroTeaserArticle>
      </CustomContainer>
    );
  }
}
